import { render, staticRenderFns } from "./SmsChipItem.vue?vue&type=template&id=455c4cf2&scoped=true&"
import script from "./SmsChipItem.vue?vue&type=script&lang=js&"
export * from "./SmsChipItem.vue?vue&type=script&lang=js&"
import style0 from "./SmsChipItem.vue?vue&type=style&index=0&id=455c4cf2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455c4cf2",
  null
  
)

export default component.exports